<template>
  <v-main class="mt-12 mt-md-16">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div class="main-header text-left pl-6 pl-md-1 mb-4">
          {{ $route.params.type == 'own' ? $t('donor.phenotype.complete_header_own') : $t('donor.phenotype.complete_header_partner') }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div class="main-subheader text-left pl-6 pl-md-1 mb-8" v-html="$route.params.type == 'own' ? $t('donor.phenotype.complete_subheader_own') : $t('donor.phenotype.complete_subheader_partner')"></div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <recipient-phenotype-component class="mb-16" :type="'reservation'" ref="recipientPhenotypeComponent"/>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import RecipientPhenotypeComponent from '../components/RecipientPhenotypeComponent.vue';

export default {
  data() {
    return {
      type: this.$route.params.type
    }
  },
  components: {
    RecipientPhenotypeComponent
  },
  mounted() {
    this.$store.dispatch('phenotypeModule/setCurrentPhenotype', this.type);
  }
}
</script>

<style lang="scss" scoped>
  .main-header {
    @include nsb-gentium-bold;
    font-size: 28px;
    line-height: 36px;
  }
  .main-subheader {
    font-size: 12px;
    line-height: 20px;
  }

  @media (min-width: 960px) {
    .main-header {
      font-size: 40px;
      line-height: 52px;
    }
    .main-subheader {
      font-size: 14px;
      line-height: 22px;
    }
  }
</style>